var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9733",
    "data-name": "Group 9733",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.061,
    height: 22.071,
    viewBox: "0 0 33.061 22.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3351",
    "data-name": "Rectangle 3351",
    width: 33.061,
    height: 22.071,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32267",
    "data-name": "Path 32267",
    d: "M30.925,0c-1.139.041-2.28.009-3.42.009Q14.7.012,1.888,0A1.828,1.828,0,0,0,0,1.895C.027,8,.013,14.112.014,20.22a2.043,2.043,0,0,0,.032.513,1.738,1.738,0,0,0,1.809,1.338H31.28a1.747,1.747,0,0,0,1.433-.672,3.767,3.767,0,0,0,.348-.675V1.36A1.922,1.922,0,0,0,30.925,0m-.221,1.3L29.31,2.354l-11.6,8.7a1.747,1.747,0,0,1-2.3.032L2.52,1.42c-.032-.024-.062-.051-.138-.114ZM31.766,19.83c-.379-.467-.721-.885-1.061-1.305l-5.9-7.294a.905.905,0,0,0-.433-.371.631.631,0,0,0-.72.224.608.608,0,0,0,.032.8c.542.681,1.093,1.355,1.641,2.031l5.54,6.845H2.215L3.9,18.682Q6.6,15.335,9.313,11.99a.734.734,0,0,0,.229-.64.61.61,0,0,0-.454-.5.633.633,0,0,0-.691.227L7.138,12.634,1.325,19.816V2.135c.086.062.161.115.235.17q6.5,4.873,12.993,9.747a3.044,3.044,0,0,0,3.962.006q6.494-4.876,12.991-9.746c.074-.056.151-.108.259-.184Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.26839f48bb86418d23c7f59c91bed017.svg";
export { ForwardRef as ReactComponent };